import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const CollaborationCTA = () => {
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/qr/MIPMGLGF4RZ5O1", "_blank");
  };

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-gradient-to-br from-primary/10 via-secondary/10 to-accent/10 rounded-3xl overflow-hidden border border-primary/20">
          <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>

          <div className="relative z-10 px-8 py-16 sm:px-12 sm:py-20 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/20 border border-primary/30 rounded-full mb-6">
              <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
              <span className="text-sm font-mono text-primary">Open for Opportunities</span>
            </div>

            <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-6">
              Let's Build Something Amazing Together
            </h2>

            <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-10">
              Whether you're looking for a technical co-founder, development partner, or someone passionate about turning ideas into reality, I'm ready to collaborate and bring fresh perspectives to your project.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4">
              <Button
                variant="default"
                size="lg"
                iconName="MessageCircle"
                iconPosition="left"
                onClick={handleWhatsAppClick}
                className="shadow-elevation-2 hover:shadow-elevation-3"
              >
                Start a Conversation
              </Button>
              <Link to="/collaboration">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Briefcase"
                  iconPosition="left"
                >
                  View Collaboration Options
                </Button>
              </Link>
            </div>

            <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={18} color="var(--color-success)" />
                <span>Quick Response Time</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={18} color="var(--color-success)" />
                <span>Flexible Collaboration</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="CheckCircle2" size={18} color="var(--color-success)" />
                <span>Fresh Perspectives</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollaborationCTA;